<template lang='pug'>
  div.pr-2.pl-2
    bionic-metrics-uncommitted(v-model='openUncommitted')
    v-progress-circular(v-if='loading' size='20' :width='2' indeterminate color='white')
    v-menu(v-if='gitMode' v-model='open' :close-on-content-click='false' offset-y left max-height='400')
      template(v-slot:activator='{on}')
        div(v-on='on' v-if='!loading').clickable
          font-awesome-icon(icon='code-branch').mr-1
          v-badge(:content='count' color='green' :value='count')
            | {{branch}}
      v-card
        v-list.pb-0
          v-list-item(@click='showUncommitted' :disabled='!count')
            v-list-item-action
              v-icon compare_arrows
            v-list-item-title
              | Show Changes
          v-list-item(@click='showCreateBranch')
            v-list-item-action
              v-icon add
            v-list-item-title
              | Create Branch
          v-divider
          v-list(dense).pb-0.pt-0
            v-subheader Change Branch
            v-list-item(v-for='b in branches' @click='changeBranch(b)' :disabled='b === branch' :key='b').branch
              v-list-item-title
                | {{b}}
    v-dialog(v-model='openCreateBranch' max-width='400px')
      v-card
        form(@submit.prevent='createBranch')
          v-card-title
            v-row(no-gutters)
              v-col
                .text-subtitle-1 Create Branch
                .text-caption.font-weight-light From Branch: {{branch}}
          v-card-text
            v-text-field(type='text' label='Branch Name' v-model='newBranch' required autofocus)
          v-card-actions
            v-spacer
            v-btn(text @click.native='openCreateBranch=false') Cancel
            v-btn(text type='submit' color='primary' :disabled='!newBranch' :loading='creatingBranch') Create Branch
</template>

<script>
import {get, size} from 'lodash';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import GitHub from '../api/github';
import BionicMetricsUncommitted from './GitUncommitted';
import Notifications from '../services/notification.service';
import Events from '../services/events.service';

export default {
  name: 'BionicMetricsGitBranch',
  components: {BionicMetricsUncommitted},
  async mounted() {
    await this.load();
    Events.$on('gitChange', this.onGitChange);
  },
  asyncComputed: {
    async branches() {
      if (!this.gitMode) return [];
      return GitHub.branches();
    }
  },
  computed: {
    count() {
      if (!this.gitMode || !this.changeMap) return 0;
      return size(this.changeMap);
    },
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount',
      changeMap: 'getChangeMap',
      gitMode: 'getGitMode',
      branch: 'getGitBranch'
    })
  },
  methods: {
    async load() {
      if (!this.gitMode) return;
      await this.getChangeMap();
    },
    async onGitChange(data) {
      const type = get(data, 'message.type');
      if (type === 'mapAdd') return this.add(get(data, 'message.item'));
      if (type === 'mapRemove') return this.remove(get(data, 'message.item'));
      if (type === 'mapReset') return this.load();
    },
    async changeBranch(branch) {
      if (branch === this.branch) return;
      try {
        this.open = false;
        this.loading = true;
        await this.changeDashboardUrls(branch); // check this
        await this.gitChangeBranch({branch, reload: true});
        Notifications.toast(`Git branch successfully changed to <strong>${branch}</strong>`);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async createBranch() {
      if (!this.newBranch) return;
      try {
        this.creatingBranch = true;
        await GitHub.createBranch(this.newBranch);
        await this.changeBranch(this.newBranch);
        this.openCreateBranch = false;
      } catch (error) {
        console.error(error);
        const message = get(error, 'response.data.message');
        if (message) await Notifications.alertError('Error creating branch. GitHub Error Details:', message);
        else await Notifications.alert('Error creating branch. Check branch name. Details logged to console');
      } finally {
        this.creatingBranch = false;
      }
    },
    async changeDashboardUrls(newBranch) {
      // If the current route matched the dashboard, need to change the URL to the new branch
      if (this.$route.matched.some(({name}) => name === 'Dashboard')) {
        console.log(window.location.pathname);
        if (!window.location.pathname.includes(newBranch)) {
          await this.$router.push(`/dashboard/${newBranch}`);
        }
      }
    },
    showUncommitted() {
      this.openUncommitted = true;
      this.open = false;
    },
    showCreateBranch() {
      this.openCreateBranch = true;
    },
    ...mapActions({
      refreshUser: 'refreshUser',
      getChangeMap: 'getChangeMap',
      gitChangeBranch: 'gitChangeBranch'
    }),
    ...mapMutations({
      add: 'addToGitMap',
      remove: 'removeToGitMap',
      reloadRouter: 'reloadRouter'
    })
  },
  data() {
    return {
      open: false,
      loading: false,
      openUncommitted: false,
      openCreateBranch: false,
      newBranch: null,
      creatingBranch: false
    };
  }
};
</script>

<style scoped>
.branch {
  min-height: 32px;
  max-height: 32px;
  height: 32px;
}
</style>
